import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, MailCheck } from "lucide-react";
import { api } from "../../../services/apiService";
import { apiMessage } from "../apiMessage";
import { AuthLayout } from "../components/AuthLayout";

export function VerifyEmailPage() {
  const [params] = useSearchParams();
  const [token, setToken] = useState(params.get("token") || "");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    setMessage("");
    setSubmitting(true);

    try {
      const response = await api.post("/auth/verify-email", { token });
      setMessage(response.data.message);
    } catch (err) {
      setError(apiMessage(err, "Verification failed"));
    } finally {
      setSubmitting(false);
    }
  };

  if (message) {
    return (
      <AuthLayout eyebrow="Account security" title="Email verified">
        <div className="auth-status">
          <div className="auth-status-icon"><CheckCircle2 size={26} /></div>
          <p style={{ color: "var(--ops-muted)", fontSize: 14, lineHeight: 1.6 }}>{message}</p>
          <Link to="/login" className="ops-button ops-button--secondary" style={{ marginTop: 20 }}>
            Continue to sign in
          </Link>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout eyebrow="Account security" title="Verify your email" subtitle="Paste the verification token from your email to activate your account.">
      <form onSubmit={submit} className="auth-form">
        <div>
          <label className="ops-form-label">Verification token</label>
          <input
            required
            className="ops-input"
            value={token}
            onChange={(e) => setToken(e.target.value)}
          />
        </div>

        {error && <div className="ops-alert ops-alert--error">{error}</div>}

        <button type="submit" className="ops-button ops-button--primary auth-submit" disabled={submitting}>
          {submitting ? "Verifying…" : "Verify email"}
        </button>
      </form>

      <div className="auth-footer">
        <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
          <MailCheck size={14} /> Check your inbox for the link
        </span>
        <Link to="/login">Back to sign in</Link>
      </div>
    </AuthLayout>
  );
}
